import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { UserRoleService } from 'src/app/my-sedgwick';
import { BaseComponent } from 'src/app/shared';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
@Component({
  selector: 'app-dialog',
  template: `
    @if (showHeader) {
      <div class="app-p2 title">
        <app-action-row>
          <h2 left1 class="app-header-2">
            {{ title | translation: translationRequest }}
          </h2>
          <div right1 style="text-align: left">
            <button
              mat-icon-button
              (click)="close(cancelResult)"
              tabindex="0"
              [attr.aria-label]="
                'Close this dialog' | translation: translationRequest
              "
            >
              <mat-icon>clear</mat-icon>
            </button>
          </div>
        </app-action-row>
      </div>
    }
    <div
      aria-label="ariaLabel"
      mat-dialog-content
      class="content"
      [style.max-width.px]="width"
      [style.padding-bottom.px]="showActions ? 24 : 0"
      title=""
    >
      <ng-content></ng-content>
    </div>

    @if (showActions) {
      <div mat-dialog-actions align="end">
        @if (showConfirm) {
          <app-button
            autofocus
            (click)="confim(confirmResult)"
            emphasis="High"
            [id]="'Save' + confirmLabel"
            [disabled]="confirmDisable"
            [loading]="confirmLoading"
            [icon]="confirmIcon"
            label="{{ confirmLabel }}"
          ></app-button>
        }
        <span class="app-button-margin"></span>
        @if (showReview) {
          <app-button
            id="btnReview"
            (click)="review('review')"
            emphasis="High"
            [id]="'Review' + reviewLabel"
            label="{{ reviewLabel }}"
          ></app-button>
        }
        <span class="app-button-margin"></span>
        @if (showBack) {
          <app-button
            id="btnCancel"
            (click)="back('back')"
            emphasis="Low"
            label="{{ backLabel }}"
          ></app-button>
        }
        <span class="app-button-margin"></span>
        @if (showCancel) {
          <app-button
            id="btnCancel"
            (click)="close(cancelResult)"
            emphasis="Low"
            label="{{ cancelLabel }}"
          ></app-button>
        }
      </div>
    }
  `,
  styles: [
    `
      @media (min-width: 700px) {
        .content {
          min-width: 340px;
        }
      }

      .content {
        color: #171c20;
      }

      .mat-icon-no-color {
        color: #67707a;
      }

      @media (max-width: 700px) {
        .calHeading {
          color: #171c20;
          font-size: 13px !important;
          font-weight: bold !important;
        }
      }
    `,
  ],
  standalone: false,
})
export class DialogComponent extends BaseComponent implements OnInit {
  @Input()
  title: string;

  @Input()
  width: number;

  @Input()
  confirmLabel: string = 'Confirm';

  @Input()
  confirmResult: string = 'confirm';

  @Input()
  cancelLabel: string = 'Cancel';

  @Input()
  backLabel: string = 'Back';

  @Input()
  reviewLabel: string = 'Review';

  @Input()
  cancelResult: string = 'cancel';

  @Input()
  showCancel: boolean = true;

  @Input()
  showConfirm: boolean = true;

  @Input()
  closeOnConfirm: boolean = false;

  @Input()
  confirmOnce: boolean = false;

  @Input()
  showActions: boolean = true;

  @Input()
  showHeader: boolean = false;

  @Input()
  actionStyle: string;

  @Input()
  ariaLabelMessage: string = 'Close';

  @Input()
  showBack: boolean = false;

  @Input()
  showReview: boolean = false;

  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });

  @Output() confirmEvent = new EventEmitter();

  @Output() reviewEvent = new EventEmitter();

  @Input() hideConfirm = () => {
    this.showConfirm = false;
  };

  @Input()
  SaveAlt: string = '';

  @Input()
  CancelAlt: string = '';

  @Output()
  testClosed: EventEmitter<string> = new EventEmitter<string>();

  @Output()
  afterClosed: EventEmitter<string> = new EventEmitter<string>();

  @Output()
  backEvent = new EventEmitter();

  @Output()
  confirmAction = new EventEmitter<object>();

  @Input()
  btnConfirmAltText: string = '';

  @Input()
  btnConfirmTitleText: string = '';

  @Input()
  btnCloseAltText: string = '';

  @Input()
  btnCloseTitleText: string = '';

  @Input()
  customeHeadingClass: string;

  @Input()
  ariaLabel: string;

  @Input()
  confirmDisable: boolean = false;

  @Input()
  confirmLoading: boolean = false;

  @Input()
  confirmIcon: string = '';

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    private userRole: UserRoleService,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super();
    this.showHeader = this.userRole.supervisor;
  }
  ngOnInit(): void {
    this.dialogRef.afterClosed().subscribe((result) => {
      this.showConfirm = true;
      this.testClosed.emit(result);
      this.afterClosed.emit(result);
    });
  }

  close(result: string) {
    this.dialogRef.close(result);
    this.afterClosed.emit(result);
    this.showConfirm = true;

    const from = this.route.snapshot.queryParamMap.get('from');
    const claimId = this.route.snapshot.queryParamMap.get('claimId');
    const source = this.route.snapshot.queryParamMap.get('source');
    const queryParams: any = {};
    if (from == 'claim') {
      const uploadlinkbtn = document.querySelectorAll('.btnlink');
      const target = uploadlinkbtn[0] as HTMLInputElement;
      target.focus();
    }
    if (from == 'commcenter') {
      queryParams.from = from;
      queryParams.claimId = claimId;
      queryParams.source = source;
      this.router.navigate(['/communication-center'], {
        queryParams,
      });
      setTimeout(() => {
        const uploadlinkbtn = document.querySelectorAll('.btnlink');
        const target = uploadlinkbtn[0] as HTMLInputElement;
        if (target) {
          target.focus();
        }
      }, 1000);
    }
  }

  confim(result: string) {
    this.confirmEvent.emit(result);
    if (this.confirmOnce === true) {
      this.showConfirm = false;
    }
    if (this.closeOnConfirm === true) {
      this.dialogRef.close();
    }
  }

  back(result: string) {
    this.backEvent.emit(result);
  }

  review(result: string) {
    this.reviewEvent.emit(result);
  }
}
